const lang ={
   en: {
    search:"search",
    gptSearchPlaceholder:"What you want to watch today?"
   } ,
   hindi: {
    search:"खोजें",
    gptSearchPlaceholder:"आज आप क्या देखना चाहते हैं"
   } ,
   spanish: {
    search:"buscar",
    gptSearchPlaceholder:"¿Qué quieres ver hoy?"
   } ,

};
export default lang;